import { MenuLayout, FormProfileAdminLayout } from "../layouts";

export const CreateProfilePage = () => {
  return (
    <>
      <MenuLayout>
        <FormProfileAdminLayout titlePage="Nuevo Perfil" />
      </MenuLayout>
    </>
  );
};
